import { detect } from 'detect-browser'
import blankWebm from '../../Assets/blank.webm'

export interface MediaFormats {
  audio: 'm4a' | 'webma',
  video: 'm4v' | 'webmv',
  canPlay?: boolean,
}

/**
 * WebM doesn't work on certain versions of Windows and IE. In these cases, we need to fallback to m4v.
 * This works by checking if the native element says it can play the type. If it can then we're fine to play WebM
 * Otherwise, check if the media will play even though it says it can't. If this happens then we need m4v
 */
export const probeForFallback = (): Promise<MediaFormats> => {
  return new Promise(resolve => {
    const browser = detect()
    if (browser?.name === 'ie') {
      const v = document.createElement('video')
      const nativeCanPlay = !!(v.canPlayType?.('video/webm; codecs="vp8, vorbis"').replace(/no/, ''))

      if (nativeCanPlay) {
        resolve({ audio: 'webma', video: 'webmv', canPlay: true })
      } else {
        v.addEventListener('error', () => {
          resolve({ audio: 'm4a', video: 'm4v', canPlay: true })
        })
        v.addEventListener('playing', () => {
          resolve({ audio: 'm4a', video: 'm4v', canPlay: true }) // IE reports it can't play webm but it actually can. This is the case where we want to use m4v
        })
        v.src = blankWebm
        v.muted = true
        v.play()

        setTimeout(() => {
          resolve({ audio: 'm4a', video: 'm4v', canPlay: true }) // failsafe: in case error or playing event isn't set after 5 seconds fallback to m4a, m4v
        }, 8000)
      }
    } else {
      resolve({ audio: 'webma', video: 'webmv' }) // use webm format
    }
  })
}
